import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRoot } from '@telegram-apps/telegram-ui';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { AppLayout } from './app/AppLayout';
import { AuthProvider, useAuth } from './shared/auth/AuthProvider';
import { ErrorState } from './components/ui';
import '@telegram-apps/telegram-ui/dist/styles.css';
import './app/styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});

function TelegramThemeSync() {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;

    tg.expand();
    const params = tg.themeParams;
    const root = document.documentElement;
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        root.style.setProperty(`--tg-theme-${key.replace(/_/g, '-')}`, value);
      }
    }
  }, []);

  return null;
}

function AppShell() {
  const auth = useAuth();

  if (!auth.ready) {
    return <div style={{ padding: 24 }}>Загрузка…</div>;
  }

  if (auth.error || !auth.token) {
    return <ErrorState message={auth.error ?? 'Авторизация не выполнена'} />;
  }

  return <AppLayout />;
}

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <AppRoot>
      <AuthProvider>
        <TelegramThemeSync />
        <HashRouter>
          <AppShell />
        </HashRouter>
      </AuthProvider>
    </AppRoot>
  </QueryClientProvider>,
);
